import { buildAxiosInstance } from '../../../../../../shared/utils/apiUtils'
import { convertFromCentValue } from '../../../../../../shared/utils/formattingUtils'
import { addToArray } from '../../../../../../shared/utils/arrayUtils'
import { type GlobalTransactionHisType } from '../../../../../../shared/types/GlobalTransactionHisType'
import { proxyRefund } from './refundProxy'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export async function executeTransactionRetrieveForRefund (id: string): Promise<void> {
  proxyRefund.apiCallRetrieveTransaction.loading = true
  proxyRefund.apiCallRetrieveTransaction.error = null
  try {
    const response = await buildAxiosInstance().post('/api/transactions/retrieve', { transactionId: id })
    if (response.data.error) {
      proxyRefund.apiCallRetrieveTransaction.error = response.data.error
    } else {
      const recentTxn: GlobalTransactionHisType = response.data?.data?.transaction ?? {}

      recentTxn.amountCents = convertFromCentValue(recentTxn.amountCents, recentTxn.amountCurrencyType)
      recentTxn.remainingAmountCents = convertFromCentValue(recentTxn.remainingAmountCents, recentTxn.remainingAmountCurrencyType)

      proxyRefund.transaction = recentTxn

      proxyRefund.formValues.email = recentTxn.email
      proxyRefund.formDirtied = addToArray(proxyRefund.formDirtied, FormFieldNamesEnum.Email)
    }
  } catch (e) {
    if (e instanceof Error) {
      proxyRefund.apiCallRetrieveTransaction.error = e.message
    }
  } finally {
    proxyRefund.apiCallRetrieveTransaction.loading = false
  }
}
